import React, { useEffect, useState } from 'react';

interface IChatProgressIndicatorProps {
    messages: string[];
    // Server-pushed (e.g. tool name in the dashboard agent flow); takes
    // precedence over the random rotation when set.
    serverMessage?: string | null;
}

// Rotates a random "thinking…" line every 1.5s, or shows the
// server-pushed message instead. Parent unmounts on first chunk.
export function ChatProgressIndicator({ messages, serverMessage }: IChatProgressIndicatorProps): JSX.Element {
    const [index, setIndex] = useState(() => Math.floor(Math.random() * Math.max(messages.length, 1)));

    useEffect(() => {
        if (serverMessage) {
            return undefined;
        }
        const intervalMs = 1500;
        const handle = setInterval(() => {
            setIndex((i) => (i + 1) % Math.max(messages.length, 1));
        }, intervalMs);
        return () => clearInterval(handle);
    }, [serverMessage, messages.length]);

    const display = serverMessage ?? messages[index] ?? '…';

    return (
        <div className="chat-progress" style={{ padding: '8px 12px', color: '#888', fontStyle: 'italic' }}>
            <i className="fa fa-spinner fa-spin" style={{ marginRight: 8 }} />
            {display}
        </div>
    );
}
